import { Box, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const ButtonText = Text.withConfig({
  color: primitive.$mayoEggWhite,
  textAlign: 'center',
  fontFamily: 'heading',
});

export const SubHeading = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '$4',
});

export const Section = Box.withConfig({
  marginY: '$3',
});

export const Container = Box.withConfig({
  width: 'full',
});
